export function testIdsServicosMateriais(prefix: string) {
  return {
    secao: `${prefix}-servicos-materiais`,
    impedimento: `${prefix}-servicos-materiais-impedimento`,
    tabela: `${prefix}-servicos-materiais-tabela`,
    item: `${prefix}-servicos-materiais-item`,
  };
}
